'use client'

import { StyledButton } from './button.styles'
import classNames from 'classnames'
import { useCallback } from 'react'
import { useGlobalState } from '../../context/globalStateProvider'
import { ArrowIcon } from '../icons/arrowIcon'

export const Button = ({
  children,
  className,
  icon = ArrowIcon,
  iconSide = 'right',
  strokeWidth = 0,
  prompt,
  href,
  trackingId,
  ...props
}) => {
  const IconComponent = icon
    const { setExternalLink, setExternalModalId } = useGlobalState();

  const externalLinkHandler = useCallback((e) => {
      e.preventDefault();
      setExternalModalId(prompt);
      setExternalLink(href);
    }, [href, prompt])

  return (
    <StyledButton
      className={classNames(className, `icon-${iconSide}`)}
      {...(prompt && { onClick: externalLinkHandler })}
      {...(href && { href })}
      strokeWidth={strokeWidth}
	    data-tracking={`body-cta-link${trackingId ? `-${trackingId}` : ''}`}
      {...props}
    >
      {icon && iconSide == 'left' && <IconComponent />}
      {children}
      {icon && iconSide == 'right' && <IconComponent />}
    </StyledButton>
  )
}
